import { CLEAR_PLACE, CLOSE_MODAL, OPEN_MODAL } from "../Action/Action";

// import { OPEN_MODAL, CLOSE_MODAL } from "./Action/Action";
const initialState = {
    active: "",
    place: localStorage.getItem("selectedCity") || "",
    isOpen: false,
    modalData: null,
};
const appReducer = (state = initialState, action) => {
    switch (action.type) {
        case "place":
            return { ...state, place: action.payload };
        case "Home":
            return { ...state, active: state.active = "0" };
        case "Hotel":
            return { ...state, active: state.active = "1" };
        case "Flight":
            return { ...state, active: state.active = "2" };
        case "Car Rentals":
            return { ...state, active: state.active = "3" };
        case "Restaurants":
            return { ...state, active: state.active = "4" };
        case "Things to do":
            return { ...state, active: state.active = "5" };
        case "Audio Tour":
            return { ...state, active: state.active = "6" };
        case "Deals":
            return { ...state, active: state.active = "7" };
        case "Blog":
            return { ...state, active: state.active = "8" };
        case "Demo":
            return { ...state, active: state.active = "9" };
        case OPEN_MODAL:
            return {
                ...state,
                isOpen: true,
                modalData: action.payload,
            };
        case CLOSE_MODAL:
            return {
                ...state,
                isOpen: false,
                modalData: null,
            };
        case CLEAR_PLACE:
            return { ...state, place: "" };
        default:
            return state;
    }
};

export default appReducer;
